import React from 'react';

// Styles & Assets
import styles from './PatientInfoTitle.module.css';

// Interfaces
interface Props {
    title: string
    onClick: React.MouseEventHandler<HTMLButtonElement>
    children: React.ReactNode
    size: number
    disabled?: boolean
}

const PatientInfoTitle: React.FC<Props> = ({ title, size, onClick, disabled, children }) => {

    return (
        <div className={styles.titleContainer}>
            <h1 className='dialogTitle'>{title}</h1>
            <button
                onClick={onClick}
                className={styles.editButton}
                disabled={disabled}
                style={{
                    width: size,
                    height: size
                }}
            >
                {children}
            </button>
        </div>
    );
};

export default PatientInfoTitle;